<template>
	<div v-parallax-fit="parallax" class="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/23_Check_Hand01@2x.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 33000,
						end: 34400,
						fromStyle: { transform: 'translateY(-500%)' },
           				toStyle: { transform: 'translateY(0%)' },
						easing: 'linear'
					},
					{
						start: 35000,
						end: 39500,
						fromStyle: { transform: 'translateY(0%) translateX(0%) rotate(0deg)' },
           				toStyle: { transform: 'translateY(-400%) translateX(-500%) rotate(180deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hand {
		position: absolute;
		top: 0;
		left: 0;
		max-width: 400px;
		width: 100%;
		transition: all 0.8s linear;
		margin-top: -470px;
		margin-left: 35px;
	}

	@media screen and (max-width: 991px) {
		.hand {
			max-width: 300px;
			margin-top: -335px;
			margin-left: 70px;
		}
	}

	@media screen and (max-width: 650px) {
		.hand {
			max-width: 170px;
		    margin-top: -162px;
		    margin-left: 70px;
		}
	}
</style>
